/**
 * 通報の理由（#256、ADR-032 A1）。アプリで選び、管理画面で件数の内訳を見る。
 *
 * | 理由                   | 何が                                           |
 * | ---------------------- | ---------------------------------------------- |
 * | `inappropriate_drawing` | 絵がよくない                                   |
 * | `inappropriate_name`    | 選手の名前・必殺技の名前がよくない             |
 * | `personal_info`         | 名前や学校名など、個人が分かることが書いてある |
 * | `other`                 | そのほか                                       |
 *
 * **自由入力の欄は作らない。** 子どもが書いた文そのものが、また見張る対象になる。
 */
export const REPORT_REASONS = [
    'inappropriate_drawing',
    'inappropriate_name',
    'personal_info',
    'other',
];
/**
 * プロフィール（ニックネームとアバター）の通報の理由（#265、ADR-032 A1）。
 *
 * | 理由                     | 何が                   |
 * | ------------------------ | ---------------------- |
 * | `inappropriate_nickname` | ニックネームがよくない |
 * | `inappropriate_avatar`   | アバターの絵がよくない |
 * | `other`                  | そのほか               |
 *
 * **個人が分かることは理由にしない。** ニックネームとアバターを見せる相手は、自分と、ともだちと対戦の相手（知っている人）だけで、
 * 名前を入れても断っていない（#258）。自由入力の欄は作らない（選手の通報と同じ）。
 */
export const PROFILE_REPORT_REASONS = [
    'inappropriate_nickname',
    'inappropriate_avatar',
    'other',
];
